"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseOverview = _interopRequireDefault(require("../BaseOverview"));
var _OverviewPublishedBy = _interopRequireDefault(require("../OverviewPublishedBy"));
var _OverviewPublishedOn = _interopRequireDefault(require("../OverviewPublishedOn"));
var _OverviewStatus = _interopRequireDefault(require("../OverviewStatus"));
var ModalOverview = function ModalOverview(_ref) {
  var asset = _ref.asset;
  return /*#__PURE__*/_react.default.createElement(_BaseOverview.default, {
    asset: asset
  }, /*#__PURE__*/_react.default.createElement(_OverviewPublishedBy.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_OverviewPublishedOn.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_OverviewStatus.default, {
    asset: asset
  }));
};
var _default = exports.default = ModalOverview;
//# sourceMappingURL=ModalOverview.js.map